import { DeepReadonly, IApplyApplicationTaskConfig } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

const applicationTaskConfig: IApplyApplicationTaskConfig = {
  EnglishLanguage: {
    default: true,
  },
  Employment: {
    default: true,
  },
  References: {
    default: true,
  },
  PersonalStatement: {
    default: true,
  },
  ResearchProposal: {
    default: false,
  },
  Funding: {
    default: true,
  },
  ImmigrationHistory: {
    default: true,
  },
  DiversityInclusion: {
    default: true,
  },
  Representation: {
    default: true,
  },
  Referral: {
    default: true,
  },
  Declarations: {
    default: true,
  },
};

export const defaultApplicationTaskConfig: DeepReadonly<IApplyApplicationTaskConfig> =
  deepFreeze(applicationTaskConfig);
